// extracted by mini-css-extract-plugin
module.exports = {"SearchEngine":"SearchEngine_SearchEngine__3UIrW","form":"SearchEngine_form__rxxXC","icon":"SearchEngine_icon__17yli"};